<div class="row-body">
  <div class="row-name" [title]="name">{{ name }}</div>
  <div class="row-bar">
    <div class="bar-track">
      <div class="bar-fill" [style.width.%]="barWidth"></div>
    </div>
  </div>
  <div class="row-count">
    <ng-container *ngIf="valueFormat === 'count'">{{
      value | thousandSuff
    }}</ng-container>
    <ng-container *ngIf="valueFormat === 'percent'">{{
      value >= 0.01 ? (value | percent) : (value | percent: '1.0-1')
    }}</ng-container>
  </div>
  <div
    class="delta-pill"
    [class.positive]="deltaClass === 'positive'"
    [class.negative]="deltaClass === 'negative'"
    [class.neutral]="deltaClass === 'neutral'"
  >
    <span class="arrow" *ngIf="deltaArrow">{{ deltaArrow }}</span>
    <span class="value">{{ deltaLabel }}</span>
  </div>
</div>

<!-- Slots are reserved on `sole` rather than on the data flags: the events
     matrix is fetched out of band and lands after the rows render, so gating
     the container itself made every row reflow when it arrived. -->
<div class="microchart-container" *ngIf="sole">
  <app-micro-chart
    *ngIf="showSparkline"
    [seriesData]="series"
    [timeframe]="microTimeframe"
    [bucketDays]="bucketDays"
  ></app-micro-chart>
  <span class="slot-pending" *ngIf="!showSparkline" aria-hidden="true"></span>
  <span class="peak-note" *ngIf="peakNote">{{ peakNote }}</span>
</div>

<div class="event-analytics-container" *ngIf="sole">
  <app-event-analytics-temporality
    *ngIf="showTemporality"
    [widths]="temporalityWidths"
  ></app-event-analytics-temporality>
  <span class="slot-pending" *ngIf="!showTemporality" aria-hidden="true"></span>
</div>
